import { observable, action, flow } from 'mobx';
import * as AuthZApi from '../apis/AuthZApi';
import history from '../history';
import StorageHelper from '../utils/StorageHelper';

const storageHelper = new StorageHelper();
export default class AuthZStore {
  @observable isEnabled = undefined;
  @observable permissions = [];
  @observable notifications = [];
  @observable
  loading = {
    getPermissions: false,
    getLoginEnabled: false
  };

  constructor(rootStore) {
    this.rootStore = rootStore;
  }

  async init() {
    try {
      this.permissions = JSON.parse(
        storageHelper.storage.getItem('permissions')
      );
    } catch (e) {}
  }

  @action
  async isAuthorized() {
    const applicationPermission = this.rootStore.configStore.config[
      this.rootStore.configStore.configurationKeys.applicationPermission
    ];
    return !!this.permissions.find(perm => perm === applicationPermission);
  }

  getLoginEnabled = flow(function*() {
    this.loading.getLoginEnabled = true;

    try {
      const federatedGraphqlHubServiceUrl = this.rootStore.configStore.config[
        this.rootStore.configStore.configurationKeys
          .federatedGraphqlHubServiceUrl
      ];

      this.isEnabled = yield AuthZApi.getLoginEnabled(
        `${federatedGraphqlHubServiceUrl}`
      );
      return this.isEnabled;
    } catch (error) {
    } finally {
      this.loading.getLoginEnabled = false;
    }
    return false;
  });

  getPermissions = flow(function*() {
    this.deletePermissions();

    this.loading.getPermissions = true;

    try {
      const federatedGraphqlHubServiceUrl = this.rootStore.configStore.config[
        this.rootStore.configStore.configurationKeys
          .federatedGraphqlHubServiceUrl
      ];
      const applicationResourceName = this.rootStore.configStore.config[
        this.rootStore.configStore.configurationKeys.applicationResourceName
      ];

      const permissions = yield AuthZApi.getPermissions(
        `${federatedGraphqlHubServiceUrl}`,
        applicationResourceName
      );

      this.storePermissions(permissions);
    } catch (error) {
    } finally {
      this.loading.getPermissions = false;
    }
  });

  @action
  storePermissions(permissions) {
    storageHelper.storage.setItem('permissions', JSON.stringify(permissions));
    this.permissions = permissions;
  }

  @action
  deletePermissions() {
    storageHelper.storage.removeItem('permissions');
    this.permissions = [];
  }

  @action
  handleUnauthorized(isSso = false) {
    if (isSso) {
      history.replace('/unauthorized?sso');
    } else {
      history.replace('/unauthorized');
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/AuthZStore.js